module.exports = __webpack_public_path__ + "static/media/oie_DfoefhEory1A.7a0459d4.png";